import { object, string, number, InferType } from "yup";

export const addressSchema = object({
  country: string().optional(),
  street_address: string().optional(),
  unit_number: string().optional(),
  locality: string().optional(),
  administrative_division_1: string().optional(),
  administrative_division_2: string().optional(),
  postal_code: string().optional(),
  start_date: string().nullable().optional(),
  address_line_1: string().optional(),
  timezone: number().nullable().optional(),
});

export type Address = InferType<typeof addressSchema>;

export function isAddress(obj: unknown): obj is Address {
  return addressSchema.isValidSync(obj);
}

export function parseAddress(
  address: unknown,
  defaultValue = addressSchema.getDefault() as Address
): Address {
  if (!isAddress(address)) {
    return defaultValue;
  }

  return address;
}

export type AddressErrors = Partial<Record<keyof Address, string | string[]>>;
